(function($) {
    $(document).ready(function() {
        $('.slick-gallery').slick({
            infinite: false,
            dots: false,
            arrows: false,
            fade: false,
            autoplay: true,
            swipe: true,
            touchMove: true,
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            asNavFor: '.slick-gallery-nav'
        });

        $('.slick-gallery-nav').slick({
            infinite: false,
            dots: false,
            arrows: false,
            autoplay: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            mobileFirst: false,
            variableWidth: false,
            adaptiveHeight: true,
            asNavFor: '.slick-gallery',
            focusOnSelect: true,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 8,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
            ]
        });


        $('.slick-image-video').slick({
            infinite: false,
            dots: false,
            arrows: false,
            fade: false,
            autoplay: true,
            swipe: true,
            touchMove: true,
            centerMode: false,
            variableWidth: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
            asNavFor: '.slick-image-video-nav'
        });

        $('.slick-image-video-nav').slick({
            infinite: false,
            dots: false,
            arrows: false,
            autoplay: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            mobileFirst: false,
            variableWidth: false,
            adaptiveHeight: false,
            asNavFor: '.slick-image-video',
            focusOnSelect: true,
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 8,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
            ]
        });


        $('.shop-slider').slick({
            infinite: true,
            dots: false,
            arrows: false,
            fade: false,
            autoplay: true,
            swipe: true,
            centerMode: false,
            adaptiveHeight: true,
            variableWidth: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: 'ondemand',
        });

    })

})( jQuery );